// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.digital-clock {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Courier New", Courier, monospace;
  font-size: var(--clock-font-size, clamp(0.7rem, min(2.5vw, 2.5vh), 2rem));
  font-weight: bold;
  color: var(--ion-color-primary);
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  text-align: center;
  padding: 2px;
  border-color: var(--ion-color-primary);
  border-radius: var(--border-radius-medium);
  border-width: 1px;
  border-style: solid;
}

@media (max-width: 599px) {
  .digital-clock {
    font-size: 12px;
    padding: 2px 4px;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .digital-clock {
    font-size: 14px;
  }
}
@media (min-width: 1024px) {
  .digital-clock {
    font-size: clamp(14px, 1.5vw, 20px);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/digital-clock/digital-clock.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8CAAA;EACA,yEAAA;EACA,iBAAA;EACA,+BAAA;EACA,uBAAA;EACA,kBAAA;EACA,wCAAA;EACA,kBAAA;EACA,YAAA;EACA,sCAAA;EACA,0CAAA;EACA,iBAAA;EACA,mBAAA;AACF;;AAEA;EACE;IACE,eAAA;IACA,gBAAA;EACF;AACF;AAEA;EACE;IACE,eAAA;EAAF;AACF;AAGA;EACE;IACE,mCAAA;EADF;AACF","sourcesContent":[".digital-clock {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-family: 'Courier New', Courier, monospace;\r\n  font-size: var(--clock-font-size, clamp(0.7rem, min(2.5vw, 2.5vh), 2rem));\r\n  font-weight: bold;\r\n  color: var(--ion-color-primary);\r\n  background-color: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n  text-align: center;\r\n  padding: 2px;\r\n  border-color: var(--ion-color-primary);\r\n  border-radius: var(--border-radius-medium);\r\n  border-width: 1px;\r\n  border-style: solid;\r\n}\r\n\r\n@media (max-width: 599px) {\r\n  .digital-clock {\r\n    font-size: 12px;\r\n    padding: 2px 4px;\r\n  }\r\n}\r\n\r\n@media (min-width: 600px) and (max-width: 1023px) {\r\n  .digital-clock {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n  .digital-clock {\r\n    font-size: clamp(14px, 1.5vw, 20px);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
